export default "__VITE_PUBLIC_ASSET__9054f925__"